import { render, staticRenderFns } from "./VerDetalleMensaje.vue?vue&type=template&id=f148abba&"
import script from "./VerDetalleMensaje.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleMensaje.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports